
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";

const ArcScatter2D = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const DataReportData = props.DataReportData

    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label } = ComponentProperties
    const KeyToUseArray = KeyToUse ? KeyToUse.split('|') : []
    

 
    const data = {
        datasets: [
            {
                label: [KeyToUseArray],
                data: DataReportData.map(x=>{ return {x: x[KeyToUseArray[0]], y: x[KeyToUseArray[1]]}}),
                backgroundColor: [
                    GetColor("PRIMARY",2)
                ],
                borderColor: [
                    'rgba(255, 99, 132, 0)',
                    'rgba(54, 162, 235, 0)',
                ],
                borderWidth: 0,
            },
        ],
    }
    const options = {
        responsive: true,        
        maintainAspectRatio: false,
        animation: false,
        // events: [],
        tooltips: {
            enabled: true
        },
        plugins: {
            legend:{
                display:true,
                position:'bottom'
            }
            

        }
    }

 
    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center">{Label}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Scatter data={data} options={options} width="50px" />
            </Grid>
        </Grid>
    )
}

export default ArcScatter2D